import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import updateWorkoutAction from '../update'
import WORKOUTS_ACTION from '../../constants/action'

function updateCompletionTimeWorkoutAction (time) {
  return updateWorkoutAction({
    type: WORKOUTS_ACTION.UPDATE_COMPLETION_TIME,
    payload: {
      key: WORKOUT_KEY.COMPLETION_TIME,
      value: time
    }
  })
}

export default updateCompletionTimeWorkoutAction
